//SET_FILTERS

export const setFilters = (payload =
{
    testSubmissionCycleYear    : [],
    testRequestIdentifier      : [],
    suppliedMaterialIdentifier : [],
    nikePPSItemNumber          : [],
    testSubmissionType         : [],
    nikeMsEndUse               : [],
    materialType               : [],
    supplierLocation           : [],
    testLabIdentifier          : [],
    labTestState               : []
}) => ({
    type : 'SET_FILTERS',
    payload
});

//SET_SEASON_FILTER
export const setSeasonFilter = (testSubmissionCycleYear = []) => ({
    type : 'SET_SEASON_FILTER',
    testSubmissionCycleYear
});

//SET_TEST_REQUEST_ID_FILTER
export const setTestRequestIdFilter = (testRequestIdentifier = []) => ({
    type : 'SET_TEST_REQUEST_ID_FILTER',
    testRequestIdentifier
});
//SET_SUPPLIED_MATERIAL_FILTER
export const setSuppliedMaterialIdentifierFilter = (suppliedMaterialIdentifier = []) => ({
    type : 'SET_SUPPLIED_MATERIAL_ID_FILTER',
    suppliedMaterialIdentifier
});
//SET_PPS_ITEM_NUMBER_FILTER
export const setNikePPSItemNumberFilter = (nikePPSItemNumber = []) => ({
    type : 'SET_NIKE_PPS_ITEM_NUMBER_FILTER',
    nikePPSItemNumber
});
//SET_TEST_SUBMISSION_TYPE_FILTER
export const setTestTypeFilter = (testSubmissionType = []) => ({
    type : 'SET_TEST_TYPE_FILTER',
    testSubmissionType
});

//SET_END_USE_TYPE_FILTER
export const setMsEndUseFilter = (nikeMsEndUse = []) => ({
    type : 'SET_END_USE_FILTER',
    nikeMsEndUse
});

//SET_MATERIAL_TYPE_FILTER
export const setMaterialTypeFilter = (materialType = []) => ({
    type : 'SET_MATERIAL_TYPE_FILTER',
    materialType
});
//SET_SUPPLIER_LOCATION_FILTER
export const setSupplierLocationFilter = (supplierLocation = []) => ({
    type : 'SET_SUPPLIER_LOCATION_FILTER',
    supplierLocation
});
//SET_LAB_FILTER
export const setLabFilter = (testLabIdentifier = []) => ({
    type : 'SET_LAB_FILTER',
    testLabIdentifier
});
//SET_LAB_STATE_TEST_FILTER
export const setLabStateTestFilter = (labTestState = []) => ({
    type : 'SET_LAB_TEST_STATE_FILTER',
    labTestState
});

//SET_LAB_TEST_STATUS_FILTER
export const setLabTestStatusFilter = (testSubmissionStatusIndicator = []) => ({
    type : 'SET_LAB_TEST_STATUS_FILTER',
    testSubmissionStatusIndicator
});


//CLEAR_FILTER_SELECTION
export const clearFilterSelection = () => ({
    type : 'CLEAR_FILTER_SELECTION'
});


// WEBPACK FOOTER //
// ./src/Actions/filters.js